import { useCallback, useEffect } from "react";

import { usePaymentPage } from "Payments/PaymentPage/PaymentPageContext";

import calculateAddOnGiftAmount from "../../calculateAddOnGiftAmount";

const ctfData = window?.data?.paymentPageData?.ctfData || {};

export default function useEnsureCtfUpdates({ addOnGift, isChecked }) {
  const {
    state: { amount, addOnAmounts, paymentMethods, selectedPaymentMethodID },
    dispatch,
  } = usePaymentPage();

  const setAddOnAmount = useCallback(
    ({ addOnID, newAmount, type }) => {
      dispatch({
        type: "setAddOnAmount",
        payload: {
          addOnID,
          amount: newAmount,
          isChecked,
          type,
        },
      });
    },
    [dispatch, isChecked]
  );

  useEffect(() => {
    const { type, addOnID } = addOnGift;
    const selectedPaymentMethod = paymentMethods.find(
      (p) => p.ID === selectedPaymentMethodID
    );
    if (type === "ctf" || type === "percentage") {
      const foundAmount = addOnAmounts.find((a) => a.addOnID === addOnID);
      const newAmount = calculateAddOnGiftAmount(
        amount,
        addOnAmounts,
        addOnGift,
        ctfData,
        selectedPaymentMethod?.paymentType
      );

      const parsedFoundAmount = parseFloat(foundAmount?.amount);
      const foundAmountIsANumber = !isNaN(parsedFoundAmount);

      if (
        (foundAmount?.amount === "" || !foundAmount) &&
        typeof newAmount === "number"
      ) {
        setAddOnAmount({ addOnID, newAmount, type });
      }

      if (foundAmountIsANumber && parsedFoundAmount !== newAmount) {
        setAddOnAmount({ addOnID, newAmount, type });
      }
    }
  }, [
    addOnAmounts,
    addOnGift,
    amount,
    paymentMethods,
    selectedPaymentMethodID,
    isChecked,
    dispatch,
    setAddOnAmount,
  ]);

  return null;
}
